import * as styles from "./ProjectEditor.css";

import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { Trans } from "@lingui/react/macro";

import { ProjectEditorBody } from "./components/ProjectEditorBody";
import { ProjectEditorHeader } from "./components/ProjectEditorHeader";
import {
  type UseProjectEditorOptions,
  useProjectEditor,
} from "./hooks/useProjectEditor";

export type ProjectEditorProps = UseProjectEditorOptions;

export function ProjectEditor({
  projectId = null,
  type = "intervention",
  onSaved,
  onCancel,
}: ProjectEditorProps): JSX.Element {
  const { loading, saving, error, conflict, save, cancel } = useProjectEditor({
    projectId,
    type,
    onSaved,
    onCancel,
  });

  return (
    <div className={styles.editor}>
      <ProjectEditorHeader type={type} />

      <ProjectEditorBody loading={loading} error={error} conflict={conflict} />

      <footer className={styles.footer}>
        <Button variant="ghost" onClick={cancel}>
          <Trans>Cancel</Trans>
        </Button>

        <Button
          variant="primary"
          loading={saving}
          disabled={loading}
          shortcut="mod+s"
          onClick={() => void save()}
        >
          <Trans>Save</Trans>
        </Button>
      </footer>
    </div>
  );
}
